import {lazy} from "react";

export const ReportRfidSingleVoyageLazy = lazy(() => import('./ReportRfidSingleVoyage'))
